<template>
	<div class="body-container">
		<headerNavigation :showLogin="false"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="site-main-container">
			<div class="page-portal-container container">
				<div class="site-container">
					<userHeader :subMenuIndex="2"></userHeader>
					<div class="portal-bs-container">
						<div class="comp-item-level-navigation-container">
							<div class="item-level-back-orders">
								<button class="back-btn btn" @click="goBack">
									<img src="../../assets/images/back.png" class="back-order-fa fa fa-chevron-left dri-arrow-left back-icon"/>
									<span class="hidden-xs hidden-sm">{{$t('order.backorder')}}</span>
									<span class="hidden-lg hidden-md">{{$t('order.backorder')}}</span>
								</button>
							</div>
							<div class="item-level-pagination">
								<span class="pull-left item-level-details">
									<span class="orderId">{{$t('order.orderno')}} {{orderMain.orderNo}}</span>
									 > <!-- {{$t('order.productnumber')}} --> {{orderMain.createTime}}
								</span>
								<!-- <span class="pull-right item-pagination">
									<button class="previous-btn btn" disabled>
										<img src="../../assets/images/left-disable.png" class="fa fa-chevron-left fa-icon dri-arrow-left left-p-icon"/>
										  
										  <span class="hidden-xs hidden-sm previous-btn-label">{{$t('order.prev')}} |</span>
									</button>   
									<span class="position-container">
										<span class="position-label">第 1项</span>，共 1 项
									</span>   
									<button class="next-btn btn" disabled>
										<span class="hidden-xs hidden-sm next-btn-label">| {{$t('order.next')}}</span>  
										<img src="../../assets/images/right-disable.png" class="fa fa-chevron-right fa-icon dri-arrow-right left-p-icon"/>
									</button>
								</span> -->
							</div>
						</div>
						<div class="comp-item-new-level-container">
							<div class="comp-job-item-breadcrumb-container">
								<ul>
									<li>
										<a>
											<span class="order-number">{{$t('order.orderno')}} {{orderMain.orderNo}}</span>
											 > <!-- {{$t('order.productnumber')}} --> {{orderMain.createTime}}
										</a>
									</li>
								</ul>
							</div>
							<div class="comp-item-view-prepress-notes-container alert alert-danger">
								<span class="alert-note">{{orderMain.orderStatusName}}<!-- <span>校样审核通过后，将计算并显示取货或送货日期。</span> --></span>
							</div>
							<div class="comp-item-view-thumbnail-container">
								<div class="item-thumbnail-preview-container">
									<div class="on-hold-thumb text-center">
										<div class="image-stack" :class="orderItems.filelist.length > 1 ? '' : 'image-stack-full'" v-if="orderItems.filelist.length > 0">
											<div class="image-card" v-for="imgs in orderItems.filelist">
												 <el-image style="width: 100%; height: 100%" :src="imgs" :preview-src-list="orderItems.filelist"></el-image>
											</div>
										</div>
										<el-image style="width: 100%; height: 100%" v-else>
										    <div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
										    </div>
										</el-image>
										<!-- <img src="../../assets/images/danger.png" class="icon-exclamation-triangle danger-icon"/>
										<br>
										<small>暂停。</small>
										<br>
										<small>等待文件。</small> -->
									</div>
								</div>
							</div>
							<div class="comp-item-view-component old-prepress-notes">
								<div class="comp-item-view-specs-container">
									<ul class="item-specs-container">
										<li class="item-specs-title" >
											<span class="product-title">{{orderItems.productName}}</span>
										</li>
										<li class="item-specs-label">
											<span class="product-label"></span>
										</li>
										<li class="item-specs-list" v-for="(item,index) in attributeslist">
											<span>
												<span class="item-specs-attr">{{item}}</span>
												<!-- <span class="item-specs-value">2英寸 x 3.5英寸（美国标准）</span> -->
											</span>
										</li>
									</ul>
									<ul class="item-subtotal-container">
										<li class="item-subtotal-list" v-if="lang == 'zh'">{{$t('order.productsubtotal')}} {{orderItems.subtotalAmount}}美元</li>
										<li class="item-subtotal-list" v-else>{{$t('order.productsubtotal')}} ${{orderItems.subtotalAmount}}</li>
									</ul>
									<div class="item-level-shipping-container">
										<div class="item-view-shipping">
											<!-- <div class="item-shipping-count-label">1 件装运中的 1 件  </div>
											<div class="service-selected">4天过境</div> -->
											<div class="company-label shipping-info-label">{{sAddress.firstname}} {{sAddress.lastname}}</div>
											<div class="address-label shipping-info-label">{{sAddress.address}}</div>
											<div class="address-label shipping-info-label">{{sAddress.country}}, {{sAddress.province}} {{sAddress.city}}</div>
											<div class="address-label shipping-info-label">
												<span>{{$t('address.phone')}}:{{sAddress.phone}}</span>
											</div>
											<br>
										</div>
									</div>
									<div class="item-level-order-placed-container">
										<label class="order-place-label">{{orderMain.createTime}}</label>
									</div>
								</div>
								<div class="comp-item-level-status-tracker-container">
									<div class="item-statuses-container">
										<div class="item-statuses-padding text-center">
											<div class="item-statuses text-left">
												<div class="icon-tracker-container test-shit icon-on-hold-bg">
													<div class="icon-tracker-review-status text-left clearfix">
														<label class="status-tracker-container">
															<img src="../../assets/images/red-file.png" v-if="orderItems.sta >= 0" class="icon-file-review icon-on-hold status-track-icon tracker-icon file-icon"/>
															<img src="../../assets/images/grey-file.png" class="icon-file-review icon-on-hold status-track-icon tracker-icon file-icon" v-else/>
															<span class="tracker-label">{{$t('order.filereview')}}</span>
														</label>
													</div>
												</div>
												<div class="icon-tracker-container test-shit icon-queued-bg">
													<div class="icon-tracker-review-status text-left clearfix">
														<label class="status-tracker-container">
															<img src="../../assets/images/red-ys.png" v-if="orderItems.sta >= 1" class="icon-printing icon-queued status-track-icon tracker-icon file-icon"/>
															<img src="../../assets/images/grey-ys.png" v-else class="icon-printing icon-queued status-track-icon tracker-icon file-icon"/>
															<span class="tracker-label">{{$t('order.printing')}}</span>
														</label>
													</div>
												</div>
												<div class="icon-tracker-container test-shit icon-queued-bg">
													<div class="icon-tracker-review-status text-left clearfix">
														<label class="status-tracker-container">
															<img src="../../assets/images/red-ship.png" v-if="orderItems.sta >= 2" class="icon-queued icon-shipping status-track-icon tracker-icon file-icon"/>
															<img src="../../assets/images/grey-ship.png" v-else class="icon-queued icon-shipping status-track-icon tracker-icon file-icon"/>
															<span class="tracker-label">{{$t('order.shipping')}}</span>
														</label>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import userHeader from '../../components/userHeader.vue'
	import {getOrderDetail} from '../../api/api.js'
	export default {
		components: {
			headerNavigation,
			footers,
			userHeader
		},
		data() {
			return {
				isMobile:false,
				orderId:'',
				orderItemId:'',
				orderItems:[],
				orderMain:{},
				lang:'',
				attributeslist:[],
				sAddress:{
					address:'',
					city:'',
					country:'',
					firstname:'',
					lastname:'',
					phone:""
				}
			};
		},
		mounted() {
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
			if(this.$route.query.no){
				this.orderId = this.$route.query.no;
				this.orderItemId = this.$route.query.oid;
				this.init()
			}
		},
		methods: {
			init(){
				var that = this;
				let params = {
					orderId:this.orderId,
					orderItemId:this.orderItemId
				}
				getOrderDetail(params).then(res => {
					if (res.code == 200) {
						that.orderMain = res.data.orderMain
						that.orderItems = res.data.dtl
						that.attributeslist = res.data.attributeslist
						that.sAddress = res.data.sAddress
					}
				})
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/order.css");
	.global-header-spacer {
	    height: 50px !important;
	    display: block !important;
	}
</style>